<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>

<div class="header-bar">
  <h1>Trade Plates</h1>
</div>

<div class="">
  <div class="">
    <div class="content-container">
      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="name"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.number.value"
              />
              <label>Number</label>
            </span>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="org"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.organisationName.value"
              />
              <label>Issued To</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
          </div>
        </div>
      </form>

      <p-table
        selectionMode="single"
        *ngIf="isLoaded; else loading"
        [(selection)]="selectedItem"
        (onLazyLoad)="onGridLazyLoad($event)"
        [value]="page.items"
        [lazy]="true"
        [rows]="this.filterVal.rows"
        [responsive]="true"
        [paginator]="true"
        [totalRecords]="page.total"
        resizableColumns="true"
        rowHover="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="number">Trade Plate Number</th>
            <th pSortableColumn="organisationName">Organisation</th>
            <th pSortableColumn="dateIssues">Date Issued</th>
            <th pSortableColumn="userName">User Name</th>
            <th pSortableColumn="isEnabled">Is Enabled</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.number }}</td>
            <td>{{ item.organisationName }}</td>
            <td>
              <span title="{{ item.dateIssued | datex : 'ddd DD MMM \'YY' }}">{{
                item.dateIssued | datex : "ddd DD MMM 'YY"
              }}</span>
            </td>
            <td>{{ item.userName }}</td>
            <td>{{ item.isEnabled ? 'Enabled' : 'Disabled' }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!--- DATATABLE DEPRECATED
      <p-dataTabl selectionMode="single"
          *ngIf="isLoaded; else loading"
          [(selection)]="selectedItem"
          (onLazyLoad)="onGridLazyLoad($event)"
          [value]="page.items"
          [lazy]="true"
          [rows]="this.filterVal.rows"
          [responsive]="true"
          [paginator]="true"
          [totalRecords]="page.total"
          resizableColumns="true"
          rowHover="true"
      >
          <p-column field="number" header="Trade Plate Number" [sortable]="tru" [editable]="false"></p-column>
          <p-column field="organisationName" header="Issued To" [sortable]="tru" [editable]="false"></p-column>
          <p-column field="dateIssued" header="Date Issued" [sortable]="tru" [editable]="false">
              <ng-template let-item="rowData" pTemplate="body">
                  <span title="{{item.dateIssued | datex:'ddd DD MMM \'YY'}}">{{item.dateIssued | datex:'ddd DD MMM \'YY'}}</span>
              </ng-template>
          </p-column>

          <p-column field="userName" header="Who Issued" [sortable]="tru" [editable]="false"></p-column>
          <p-column field="isEnabled" header="Status" [sortable]="tru" [editable]="false">
              <ng-template let-item="rowData" pTemplate="body">
                  {{ item.isEnabled ? 'Enabled': 'Disabled' }}
              </ng-template>
          </p-column>
      </p-dataTable>
      --->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          pButton
          (click)="enableDisableUser(selectedItem)"
          [label]="selectedItem && selectedItem.isEnabled ? 'Disable' : 'Enable'"
          [ngClass]="
            selectedItem && selectedItem.isEnabled
              ? 'btn-to-right ui-button-danger'
              : 'btn-to-right ui-button-success'
          "
          [disabled]="!selectedItem"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          (click)="onEdit(selectedItem)"
          label="Edit"
          icon="fa ui-icon-mode-edit"
          [disabled]="!selectedItem"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
        <button
          class="btn-to-right"
          type="button"
          (click)="downloadToCSV()"
          label="Download to CSV"
          pButton
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>

<p-dialog
  header="Trade Plate"
  [(visible)]="displayDialog"
  [responsive]="true"
  [style]="{ width: '400px', height: '250px' }"
  [modal]="true"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form (ngSubmit)="save(tradePlate)" autocomplete="off">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-grid-col-4"><label for="number">Number</label></div>
        <div class="ui-grid-col-8">
          <input
            [disabled]="tradePlate.id != 0"
            name="number"
            pInputText
            id="number"
            [(ngModel)]="tradePlate.number"
            maxlength="6"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-4"><label for="organisationId">Enabled</label></div>
        <div class="ui-grid-col-8">
          <p-checkbox
            binary="true"
            name="isEnabled"
            [(ngModel)]="tradePlate.isEnabled"
          ></p-checkbox>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-4"><label for="organisationId">Issued To</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown
            [disabled]="!tradePlate.isEnabled"
            name="organisationId"
            [style]="{ width: '100%' }"
            filter="true"
            [options]="suppliers"
            id="organisationId"
            [(ngModel)]="tradePlate.organisationId"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div style="float: right; margin-top: 10px">
      <button
        type="submit"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        [disabled]="!isValidNumber(tradePlate.number)"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="close()"
      ></button>
    </div>
  </form>
</p-dialog>
